import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  variant?: 'dark' | 'light';
}
export function CountdownTimer({
  variant = 'dark'
}: CountdownTimerProps) {
  const {
    minutes,
    seconds
  } = useCountdown();
  const isLight = variant === 'light';
  const boxClass = isLight ? 'bg-white text-blue-900 border border-blue-100' : 'bg-red-700 text-white border border-red-500 shadow-inner';
  const labelClass = isLight ? 'text-blue-200' : 'text-red-200';
  return <div className="flex items-center justify-center gap-2 font-mono" data-id="element-41">
      <div className="flex flex-col items-center" data-id="element-42">
        <div className={`w-12 h-12 flex items-center justify-center rounded-lg text-xl font-bold ${boxClass}`} data-id="element-43">
          00
        </div>
        <span className={`text-[10px] uppercase mt-1 font-sans font-semibold tracking-wider ${labelClass}`} data-id="element-44">
          Ore
        </span>
      </div>

      <div className={`text-2xl font-bold pb-4 ${isLight ? 'text-white' : 'text-red-700'}`} data-id="element-45">
        :
      </div>

      <div className="flex flex-col items-center" data-id="element-46">
        <div className={`w-12 h-12 flex items-center justify-center rounded-lg text-xl font-bold ${boxClass}`} data-id="element-47">
          {minutes}
        </div>
        <span className={`text-[10px] uppercase mt-1 font-sans font-semibold tracking-wider ${labelClass}`} data-id="element-48">
          Min
        </span>
      </div>

      <div className={`text-2xl font-bold pb-4 ${isLight ? 'text-white' : 'text-red-700'}`} data-id="element-49">
        :
      </div>

      <div className="flex flex-col items-center" data-id="element-50">
        <div className={`w-12 h-12 flex items-center justify-center rounded-lg text-xl font-bold ${boxClass}`} data-id="element-51">
          {seconds}
        </div>
        <span className={`text-[10px] uppercase mt-1 font-sans font-semibold tracking-wider ${labelClass}`} data-id="element-52">
          Sec
        </span>
      </div>
    </div>;
}